import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";

import HelperIcon from "src/components/icons/purposed/HelperIcon/HelperIcon";
import { EditIcon } from "../ActionIcons";
import {
  DoneAllIcon,
  DoneIcon,
  HourglassIcon,
  WarningIcon,
} from "../ResultIcons";

const styles = {
  div1: {
    minHeight: "1em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default function IconsContainer(props) {
  // show icons
  const editOpacity = props.editOpacity || 1;
  const showSuccess = props.showSuccess || false;
  const showHourglass = props.showHourglass || false;
  const showEdit = props.showEdit || false;
  const showWarning = props.showWarning || false;
  const showDoneAll = props.showDoneAllIcon || false;
  const helpId = props.helpId || null;
  const showHelp = props.helpId || false;

  // icons settings
  const fontSize = props.fontSize != null ? props.fontSize : "medium";
  const iconColor = props.iconColor != null ? props.iconColor : "primary";
  const toolTipTxt = props.toolTipTxt != null ? props.toolTipTxt : "";
  const iconTxt = props.iconTxt || null;

  return (
    <div className="noPrint">
      <div style={styles.div1}>
        <Tooltip title={toolTipTxt} arrow disableInteractive>
          <>
            {iconTxt}
            {showDoneAll && (
              <DoneAllIcon
                color={iconColor || "success"}
                fontSize={fontSize}
                sx={{ transition: "all 0.7s ease-in-out" }}
              />
            )}
            {showHourglass && (
              <HourglassIcon
                color={iconColor || "warning"}
                fontSize={fontSize}
                sx={{ transition: "all 0.7s ease-in-out" }}
              />
            )}
            {showSuccess && (
              <DoneIcon
                color={iconColor || "success"}
                fontSize={fontSize}
                sx={{ transition: "all 0.7s ease-in-out" }}
              />
            )}
            {showWarning && (
              <WarningIcon
                color={iconColor || "warning"}
                fontSize={fontSize}
                sx={{ transition: "all 0.7s ease-in-out" }}
              />
            )}
            {showEdit && (
              <EditIcon
                color={iconColor || "primary"}
                fontSize={fontSize}
                sx={{
                  transition: "all 0.7s ease-in-out",
                  opacity: editOpacity,
                  "&:hover": {
                    boxShadow: "4px 4px 2px rgba(100, 100, 100, 0.25)",
                    borderRadius: "8px",
                    opacity: 0.9,
                    fontSize: "2em",
                  },
                }}
              />
            )}

            {props.children}
          </>
        </Tooltip>
        {showHelp && <HelperIcon helpId={helpId} />}
      </div>
    </div>
  );
}

IconsContainer.propTypes = {
  showSuccess: PropTypes.bool,
  showHourglass: PropTypes.bool,
  showDone: PropTypes.bool,
  showShow: PropTypes.bool,
  showEdit: PropTypes.bool,
  showWarning: PropTypes.bool,
  showDoneAllIcon: PropTypes.bool,
  helpId: PropTypes.string,
  showHelp: PropTypes.bool,
  fontSize: PropTypes.string,
  iconColor: PropTypes.string,
  toolTipTxt: PropTypes.string,
  iconTxt: PropTypes.string,
  children: PropTypes.node,
  editOpacity: PropTypes.number,
};
